import {css, StyleSheet} from 'aphrodite';
import React from 'react';
import {noop} from 'underscore';

import {EXTERNAL_FILE_TYPE} from 'constants/PreviewTypeConstants';
import ExternalFileOptions from 'external-files/ExternalFileOptions';
import ExternalFilePreview from 'external-files/ExternalFilePreview';
import {performSignedFileQuery} from 'external-files/ExternalFileUtils';
import navigateToURL from 'lib/navigateToURL';
import * as NoteLinkedFileDAO from 'notebook/notes/attachments/NoteLinkedFileDAO';

export interface NoteLinkedFilePreviewPageProps {
  encodedUrl: string;
  encodedSourceUrl: string;
  id: string;
  owningEntityApiId: string;
  encodedName: string;
  noteLinkedFileId: string;
  isPreviewTransformed: string;
  encodedAvailablePreviewTypes: string;
  previewType?: EXTERNAL_FILE_TYPE;
}

export default function NoteLinkedFilePreviewPage(props: NoteLinkedFilePreviewPageProps): JSX.Element {
  const {
    previewType,
    encodedUrl,
    id,
    owningEntityApiId,
    encodedName,
    noteLinkedFileId,
    isPreviewTransformed,
    encodedSourceUrl,
    encodedAvailablePreviewTypes,
  } = props;
  const url = decodeURIComponent(encodedUrl);
  const availablePreviewTypes = decodeURIComponent(encodedAvailablePreviewTypes).split(',');
  return (
    <div className={css(styles.container)}>
      <ExternalFileOptions
        availablePreviewTypes={availablePreviewTypes as Array<EXTERNAL_FILE_TYPE>}
        previewType={previewType ?? null}
        updatePreviewType={noop}
        printOptions={[]}
        generateDownloadUrl={async (isPreview) =>
          isPreview
            ? await performSignedFileQuery(id, url, owningEntityApiId)
            : NoteLinkedFileDAO.getDownloadURLFromEncodedName({
                uuid: noteLinkedFileId,
                encodedName,
              })
        }
        isPreviewTransformed={isPreviewTransformed === 'true'}
        closeTab={() => {
          navigateToURL(decodeURIComponent(encodedSourceUrl));
        }}
        useAutoHeight={true}
      />
      <ExternalFilePreview
        url={url}
        externalFileId={id}
        previewType={previewType}
        owningEntityApiId={owningEntityApiId}
        useFullHeight={true}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    height: '100%',
    width: '100%',
  },
});
